export default __webpack_public_path__ + "static/media/65t.cf8e9801.jpg";